import { SinatraState } from '@rsos/sinatra';

export const loggedInSelector = (state: { sinatra: SinatraState }) => {
  return state.sinatra.user.isLoggedIn;
};
